module.exports = __webpack_public_path__ + "img/hopways-03.ff8584f3.jpeg";